// Typelizer digest c7048e0b0abffecafdcb33423f1db668
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from './runtime'
import { buildUrl } from './runtime'

export default {
  /** GET /field_groups */
  index: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/field_groups', {}, options),
    method: 'get',
  }),

  /** POST /field_groups */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/field_groups', {}, options),
    method: 'post',
  }),

  /** GET /field_groups/:id */
  show: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/field_groups/:id', params, options),
    method: 'get',
  }),

  /** PATCH /field_groups/:id */
  update: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'patch'> => ({
    url: buildUrl('/field_groups/:id', params, options),
    method: 'patch',
  }),

  /** DELETE /field_groups/:id */
  destroy: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'delete'> => ({
    url: buildUrl('/field_groups/:id', params, options),
    method: 'delete',
  }),
}
